import HttpService from './commons/HttpService';

const EmployeeService = {
  save(employee) {
    if (employee.id && employee.id > 0) {
      return this.update(employee);
    }
    return this.create(employee);
  },
  create(employee) {
    return HttpService.post('/employees', employee);
  },
  update(employee) {
    return HttpService.put(`/employees/${employee.id}`, employee);
  },
  delete(employee) {
    return HttpService.delete(`/employees/${employee.id}`);
  },
  getById(id) {
    return HttpService.get(`/employees/${id}`);
  },
  findAllForCurrentCompany(professionalOnly, excludeAgendaOnly) {
    return HttpService.get('/employees', { params: { professionalOnly, excludeAgendaOnly } });
  },
  findAllEmployeesProfessional({ excludeThirdParties, includeDeleted }) {
    return HttpService.get('/employees/professionals', { params: { excludeThirdParties, includeDeleted } });
  },
  findAllEmployeesFilterAdvanced({ professionalOnly, excludeThirdParties, includeDeleted }) {
    return HttpService.get('/employees/filterAdvanced', {
      params: { professionalOnly, excludeThirdParties, includeDeleted },
    });
  },
  enable(employeeId) {
    return HttpService.put(`/employees/${employeeId}/enabled`);
  },
  disable(employeeId) {
    return HttpService.put(`/employees/${employeeId}/disabled`);
  },
  hasFutureAppointments(employeeId) {
    return HttpService.get(`/employees/${employeeId}/hasFutureAppointments`);
  },

  // COMMISSION SETTINGS
  getCommissionSettings(employeeId) {
    return HttpService.get(`/employees/${employeeId}/commissionSettings`);
  },
  updateCommissionSettings(employeeId, form) {
    return HttpService.put(`/employees/${employeeId}/commissionSettings`, form);
  },

  updateAvatar({ employeeId, file }) {
    const formData = new FormData();
    formData.append('file', file);

    const config = { headers: { 'content-type': 'multipart/form-data' } };
    return HttpService.put(`/employees/${employeeId}/avatar`, formData, config);
  },
  deleteAvatar(employeeId) {
    return HttpService.delete(`/employees/${employeeId}/avatar`);
  },
};

export default EmployeeService;
